import { ApiProperty } from "@nestjs/swagger";

export class ItemCategoryIdReq{
    @ApiProperty()
    itemCategoryId:number;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    saleOrderId?:number;
}